import React from 'react';
import { clsx } from 'clsx';
import classes from './SkeletonBox.module.css.js';
import '@styled-system/css';
import merge from 'deepmerge';
import { jsx } from 'react/jsx-runtime';

const SkeletonBox = /*#__PURE__*/React.forwardRef(function SkeletonBox({
  height,
  width,
  className,
  style,
  ...props
}, ref) {
  return /*#__PURE__*/jsx("div", {
    className: clsx(className, classes.SkeletonBox),
    style: merge(style, {
      height,
      width
    }),
    ...props,
    ref: ref
  });
});

export { SkeletonBox };
